import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { Container, Stack, Tab, Tabs, } from '@mui/material';
import { useTheme } from '@emotion/react';
import EmployeeView from './EmployeeView';
import UserView from './UserView';
import BulkImportUsers from './BulkImportUsers';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    <Typography component={"div"}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

const UserListing = ({ jobstatus }) => {
    const theme = useTheme()
    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };


    return (
        <Container maxWidth="xl">
            <Stack>
                <Box sx={{ mb: 2, mt: 3 }}>
                    <Typography sx={{ position: 'relative', pl: 1, fontSize: { xs: 20, md: 22, xl: 25 }, fontWeight: theme.palette.mode === "dark" ? '400' : '500', "&::after": { content: '""', position: 'absolute', background: '#f764a3', width: '3px', left: 0, top: '12.5%', bottom: '12.5%', borderRadius: 1 } }}>Users</Typography>
                </Box>
            </Stack>
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        <Tab label="Admin" />
                        <Tab label="Client" />
                        <Tab label="Editor" />
                        <Tab label="QC" />
                        <Tab label="BulkImportUsers" />
                    </Tabs>
                </Box>

                <TabPanel value={tabValue} index={0}>
                    <UserView roleId={2} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                    <UserView roleId={5} />
                </TabPanel>
                <TabPanel value={tabValue} index={2}>
                    <EmployeeView roleId={4} />
                </TabPanel>
                <TabPanel value={tabValue} index={3}>
                    <EmployeeView roleId={3} />
                </TabPanel>
                <TabPanel value={tabValue} index={4}>
                    <BulkImportUsers />
                </TabPanel>
            </Box>
        </Container>

    );

}

export default UserListing